// MessageModel.js
import { v4 as uuidv4 } from 'uuid';

export const createMessage = (sender, receiver, content, threadId = null, language = 'en') => {
    return {
        p_id: uuidv4(),               // Generate a unique ID for the message
        sender,
        receiver,
        content,
        thread_id: threadId,          // Existing thread ID or a new one
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        is_read: false,
        is_deleted: false,
        language: language,           // Include the language field
    };
};
